export default (
  blob: Blob,
  imgContainer?: HTMLDivElement | null,
  callback?: (recordingScreenshot: string) => void
): Promise<Blob | string> | void => {
  const url: string = URL.createObjectURL(blob);
  const video = document.createElement('video') as HTMLVideoElement;
  const canvas = document.createElement('canvas') as HTMLCanvasElement;

  const drawCanvasImage = () => {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas
      .getContext('2d')
      ?.drawImage(video, 0, 0, canvas.width, canvas.height);
  };

  const snapImage = () => {
    drawCanvasImage();
    const imageURL: string = canvas.toDataURL();
    const success: boolean = imageURL.length > 100000;
    if (success && imgContainer) {
      const img = document.createElement('img') as HTMLImageElement;
      img.src = imageURL;
      imgContainer.appendChild(img);
      URL.revokeObjectURL(url);
    }
    return success;
  };

  const timeupdate = () => {
    if (snapImage()) {
      video.removeEventListener('timeupdate', timeupdate);
      video.pause();
    }
  };

  // Original behavior for when imgContainer is provided
  const fileReader = new FileReader();

  fileReader.onload = () => {
    video.addEventListener('loadeddata', () => {
      if (snapImage()) {
        const screenshotURL = canvas.toDataURL('image/jpg');
        if (callback) callback(screenshotURL);
        video.removeEventListener('timeupdate', timeupdate);
      }
    });
    video.addEventListener('timeupdate', timeupdate);
    video.preload = 'metadata';
    video.src = url;
    // Load video in Safari / IE11
    video.muted = true;
    video.playsInline = true;
    video.play();
  };

  fileReader.readAsArrayBuffer(blob);
};
